module.exports = __webpack_public_path__ + "media/images/logo_text_en-7ad09ded4bc80f999cf11ef05e960b0b.svg";